module.exports = __webpack_public_path__ + "static/adhesif-099cb88f8a6bbd0bac6a4351a3967f15.jpg";